import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import SimpleReactValidator from 'simple-react-validator';
import { saveReturnOrderList } from '../../actions/returnOrder'
import { withRouter } from 'react-router-dom'
import Success from "./success-page"
import { toast } from 'react-toastify';

class ReturnCart extends Component {

    constructor() {
        super()
        this.state = {
            preffered_time_slot_from:'10:00',
            preffered_time_slot_to:'12:00',
        }
        this.loginValidator = new SimpleReactValidator();
        this.validator = new SimpleReactValidator({
            messages: {
                to_time: 'Please provide Password for your account.',
            }
        });
    }

    isShippingAddress() {
        const { userInfo } = this.props
        if (!userInfo.COM_ADDRESS1 || !userInfo.COM_PIN) return false
        return true
    }
    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleProcessReturn = (event) => {
        const { connection_id, returnOrderFilterList, userInfo, userDetails } = this.props
        if(returnOrderFilterList.length !== 0){
            event.preventDefault();
            if (this.validator.allValid()) {
            const options = {
                connection_id: connection_id,
                orders: returnOrderFilterList,
                pickup_address: {                    
                    "consumer_name":userDetails.COM_FNAME,
                    "consumer_mobile_no":userDetails.COM_CONSUMER_MOBILE_NO,
                    "address_line_1": userInfo.COM_ADDRESS1,
                    "address_line_2": userInfo.COM_ADDRESS2,
                    "address_line_3": userInfo.COM_ADDRESS3,
                    "city": userInfo.COM_TOWN_NAME,
                    "state": userInfo.COM_STATE_NAME,
                    "country": userInfo.COM_CONTRY_NAME,
                    "pincode": userInfo.COM_PIN,
                    "preffered_time_slot_from": this.state.preffered_time_slot_from,
                    "preffered_time_slot_to": this.state.preffered_time_slot_to
                }
            }
            this.props.saveReturnOrderList(options)
            }
            else{
                this.validator.showMessages();
                this.forceUpdate();
               
            }
        }else {
            toast.error("Please select a Product to proceed with Return Order.")
        }
    }

    render() {
        const {loading, userInfo, returnOrderFilterList, success, returnOrderProduct} = this.props  
        if (loading){
            return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                            <div className="loading-cls"></div>
                        </div>
                    </div>
                </div>
            )
        }
        if (!!success) {
            return <>
                <Success {...this.props} />
            </>
        }
        return (
            <div>

                {/*SEO Support*/}
                <Helmet>
                <title>{this.props.customer_name}   | Return Cart</title>
                    <meta name="description" content="" />
                </Helmet>
                {/*SEO Support End */}
                <section className="m-0 p-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6" style={{ marginTop: "2%" }}>
                                <div className="custom-title">
                                    <span>Return Cart</span>
                                </div>

                                {/* List of return products */}

                                <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                {returnOrderFilterList.length !== 0 ? (
                                    
                                <div>
                                    <div className="checkout-address-title">
                                        <div className="row" style={{ marginTop: "2%" }}>
                                            <div className="col-lg-6">
                                                <p>Product Name</p>
                                            </div>
                                            <div className="col-lg-6">
                                                <p>Product Quantity</p>
                                            </div>
                                        </div>
                                        {returnOrderProduct.map((returnOrderResult, index) => {
                                           
                                            return (
                                                <div className="row return-order" key={index}>
                                                    <div className="col-lg-6">
                                                        <p>{returnOrderResult.SKU_DESC}</p>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <p>{returnOrderResult.RID_RETURN_QTY}</p>
                                                    </div>
                                                </div>
                                                )
                                            })
                                        } 
                                    
                                    </div>
                                    <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                    <div className="checkout-address-title">
                                    <div className="row return-order">
                                            <div className="col-lg-6">
                                                <p><b>Return Quantity</b></p>
                                            </div>
                                            <div className="col-lg-6">
                                                <p><b>{returnOrderFilterList.length}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                )
                                :
                                <div className="checkout-no-address"> <h3>No Products</h3> </div>
                                }

                                {/* end List of return products */}

                                <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                <div>
                                    {this.isShippingAddress() ? (
                                        <div className="checkout-address-title">
                                            Pickup Location
                                            <div className="checkout-address">
                                                <div className="address">
                                                    <p>{userInfo.COM_SALUTATION} {userInfo.COM_FNAME} {userInfo.COM_LNAME}</p>
                                                    <p>{userInfo.COM_ADDRESS1}, {userInfo.COM_ADDRESS2}, {userInfo.COM_ADDRESS3}</p>
                                                    <p>{userInfo.COM_TOWN_NAME}, {userInfo.COM_STATE_NAME}-{userInfo.COM_PIN}, {userInfo.COM_CONTRY_NAME}</p>
                                                </div>
                                                <div className="edit-address" onClick={() => this.props.history.push('/profile/edit-address')}><span>Edit Address</span></div>
                                            </div>
                                        </div>
                                    ) :
                                        <div className="checkout-no-address"> <button className="btn btn-solid" style={{ padding: "10px 27px", }} onClick={() => this.props.history.push('/profile/edit-address')}>Add Shipping Address</button> </div>
                                    }
                                    <div className="custom-divider" style={{ marginBottom: 0 }}></div>
                                    
                                </div>

                                {/* Time Slot */}

                                <div className="custom-divider" style={{ marginBottom: 0 }}></div>

                                 <div className="checkout-address-title">
                                <div className="return-order-time" style={{ marginTop: "2%" }}>
                                    <p>Pickup TimeSlot</p>
                                    <form className="theme-form">
                                        <div className="form-row">
                                        <div className="col-md-7" style={{ marginTop: "3%" }}>
                                            <label htmlFor="name">Select Preferred from slot</label>
                                            <input className="form-control" type="time" min="09:00" max="18:00" value={this.state.preffered_time_slot_from} name="preffered_time_slot_from" onChange={(e) => this.handleChange(e)} required />
                                            {this.validator.message('from_time', this.state.preffered_time_slot_from, 'required|preffered_time_slot_from',  {messages: "from_time"})}
                                        </div>
                                        <div className="col-md-7" style={{ marginTop: "2%" }}>
                                            <label htmlFor="name">Select Preferred to slot</label>
                                            <input className="form-control" type="time" min="09:00" max="18:00" value={this.state.preffered_time_slot_to} name="preffered_time_slot_to" onChange={(e) => this.handleChange(e)} />
                                            {this.validator.message('to_time', this.state.preffered_time_slot_to, 'required')}
                                        </div>
                                        </div>
                                    </form>
                                </div>
                                <div>
                                </div>
                                    
                                </div>

                                {/* end Time Slot */}


                                <div className="checkout-footer">
                                    <div className="checkout-buttons">
                                        <div className="col-6 text-center">
                                            <button className="btn btn-solid" style={{ width: "100%" }} onClick={() => this.props.history.goBack()}>Back</button>
                                        </div>
                                        <div className="col-6 text-center">
                                            <button className="btn btn-solid" style={{ width: "100%" }} onClick={(e) => this.handleProcessReturn(e)}>Process Return</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    symbol: state.data.symbol,
    userInfo: state.user.user_details,
    connection_id: state.tenant.connection_id,
    userDetails: state.user.user_details,
    success: state.returnOrder.success,
    successLoading: state.returnOrder.successLoading,
    loading: state.returnOrder.loading,
    error: state.returnOrder.error,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    returnOrderFilterList : state.returnOrder.returnOrderFilterList,
    returnOrderProduct: state.returnOrder.returnOrderProduct,
})


export default connect(
    mapStateToProps,
    { saveReturnOrderList }
)(withRouter(ReturnCart))